<script setup>
import PurchasesList from '@/components/PurchasesList.vue';

defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
</script>
<template>
  <section
    :id="data.id"
    class="section"
    :class="[
      data?.background_color ? `bg-${data.background_color}` : '',
      data?.spacing?.top ? `section--top-${data.spacing.top}` : '',
      data?.spacing?.bottom ? `section--bottom-${data.spacing.bottom}` : '',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div class="container">
      <div class="purchases">
        <h1
          class="mb-0 promos__title h2"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          v-html="data.title"
        ></h1>
        <PurchasesList
          :tabs="data.tabs"
          :background-color="data?.background_color"
        />
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use 'sass:math';
.purchases {
  display: flex;
  flex-direction: column;
  gap: 32px;
  @include media-breakpoint-up(sm) {
    gap: 48px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 48);
  }
}
</style>
